var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrainSimple = function SvgIconTrainSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M17.25 15.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.125 5.25A3.25 3.25 0 0 1 6.375 2h11.25a3.25 3.25 0 0 1 3.25 3.25v12a3.25 3.25 0 0 1-3.25 3.25H17l1.05 1.4a1 1 0 0 1-1.6 1.2l-1.95-2.6h-5l-1.95 2.6a1 1 0 1 1-1.6-1.2L7 20.5h-.625a3.25 3.25 0 0 1-3.25-3.25zm2 0c0-.69.56-1.25 1.25-1.25h11.25c.69 0 1.25.56 1.25 1.25V11H5.125zm1.25 13.25c-.69 0-1.25-.56-1.25-1.25V13h13.75v4.25c0 .69-.56 1.25-1.25 1.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTrainSimple;